module.exports = __webpack_public_path__ + "static/media/alkermes.173f0625.png";